import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 w-lg-500px rounded shadow-sm px-0 py-5 p-lg-10 mx-auto" }
const _hoisted_2 = { class: "nav nav-tabs nav-line-tabs nav-line-tabs-2x fs-5 justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link active",
    "data-bs-toggle": "tab"
  }, "เข้าสู่ระบบ")
], -1)
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = {
  class: "tab-content px-10 py-5",
  id: "myTabContent"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "tab_pane_login",
  role: "tabpanel"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "tab_pane_register",
  role: "tabpanel"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BxLogin = _resolveComponent("BxLogin")!
  const _component_PopupLoader = _resolveComponent("PopupLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("li", _hoisted_4, [
          (_ctx.seoId)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'seo-link', params: { id: _ctx.seoId } },
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("สมัครสมาชิก ")
                ]),
                _: 1
              }, 8, ["to"]))
            : (_ctx.sponsorId)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: 'sponsor-link', params: { id: _ctx.sponsorId } },
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("สมัครสมาชิก ")
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: { name: 'sign-up' },
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("สมัครสมาชิก ")
                  ]),
                  _: 1
                }))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BxLogin)
        ]),
        _hoisted_7
      ])
    ]),
    _createVNode(_component_PopupLoader, { popupId: 'register' })
  ], 64))
}